import { useEffect } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import { useParams, useRouteMatch } from 'react-router-dom';
import { useLocation } from 'react-use';

import { dataLoadRequest, setShouldResetFlow } from '../store/data/data.actions';
import { loadStatusesRequest } from '../store/statuses/statuses.actions';
import { getShouldResetFlow } from '../store/data/data.selectors';
import { fetchUsers } from '../../../store/users/users.actions';
import { fetchCountries } from '../../../store/countries/countries.actions';
import { fetchBranding } from '../../../store/branding/branding.actions';

/**
 * Hook for start data loading in the Recipient module.
 * One more actions is happening here. We save user data in the local storage to have them if user reloads a page.
 * If user loads RLP or reload it we reset this data to prevent some wrong data for another gift.
 * And if the reloading page is not RLP we cancel resetting flow data.
 */
export default (): void => {
  const { hashId } = useParams<{ hashId: string }>();
  const dispatch = useDispatch();

  const { url: parentUrl } = useRouteMatch();
  const { pathname } = useLocation();
  const shouldResetFlow = useSelector(getShouldResetFlow);

  // Cancel gift flow data resetting if user reloads page instead RLP
  if (shouldResetFlow && pathname !== parentUrl) {
    dispatch(setShouldResetFlow(false));
  }

  useEffect(() => {
    batch(() => {
      dispatch(fetchCountries.pending({ hashId }));
      dispatch(fetchBranding.pending({ hashId }));
      dispatch(fetchUsers.pending({ hashId }));
      dispatch(dataLoadRequest({ hashId }));
      dispatch(loadStatusesRequest({ hashId }));
    });
  }, [hashId, dispatch]);
};
